export default function AssessmentsDirective() {
  return {
    template: require('./assessments.html'),
    scope: {
      incompleteAssessments: '=',
      hasIncompleteAssessments: '=',
      completedAssessments: '=',
      hasCompletedAssessments: '=',
      isNavantaUser: '=',
    },
    controller: 'PRAAssessmentsController',
    controllerAs: 'assessmentsVM',
    bindToController: true,
    replace: true,
  };
}
